import { Component, ElementRef, OnInit } from '@angular/core';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { Router } from '@angular/router';
import { MobileEcatalogService } from "../mobile-ecatalog.service";
import { NzMessageService } from 'ng-zorro-antd/message';
import { version } from 'process';


@Component({
  selector: 'app-mobile-vehicle-search',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductVehicleSearchComponent implements OnInit {
  stepName: string = "brand";
  selectVehicle: any = {
    displacement:  "",
    manuId: 0,
    manufacturer: "",
    modelClass: "",
    brand: "",
    modelId: "",
    linkageTargetId: "",
    linkageTargetType: "",
  };
  vehicleBrandList: any[] = [];
  vehicleSeriesList: any[] = [];
  vehicleTypeList: any[] = [];
  vehicleYearList: any[] = [];
  vehicleDisplacementList: any[] = [];

  get selectVehicleParams(){
    const { brand, modelClass, linkageTargetType, displacement, year } = this.selectVehicle;
    const arr = [ brand, modelClass, linkageTargetType, displacement, year ].filter(item=> !!item)
    return arr?.join(' - ');
  }

  get showConfirmButton(){
    return ['brand', 'year'].includes(this.stepName)
  }

  constructor(
    private ecatalogService: EcatalogService,
    public router: Router,
    private message: NzMessageService,
    private mobileProductService: MobileEcatalogService
  ) {
    console.log('Constructor initialization');
  }

  ngOnInit(): void {
    this.stepName = "brand";
    this.getVehicleBrandList();
  }
  ngOnDestroy() {
    this.stepName = "brand";
  }
  // 获取车辆品牌列表
  getVehicleBrandList():void {
    this.ecatalogService.getManufacturers({}).subscribe(res=>{
      this.vehicleBrandList = res.rtnData || [];
      if(this.vehicleBrandList?.length > 0){
        this.getVehicleSeries(this.vehicleBrandList[0]);
      }
    });
  }
  // 获取车辆品牌系列
  getVehicleSeries(menu: any):void {
    this.selectVehicle = {
      displacement:  "",
      manuId: menu.manuId,
      manufacturer: "",
      modelClass: "",
      brand: menu.manuName,
      modelId: ""
    };
    this.ecatalogService.queryVehicleModelSeries({
      manuId: menu.manuId
    }).subscribe(res=>{
      this.vehicleSeriesList = res.rtnData || [];
    });
  }


  // 获取车辆品牌排量、年款
  handleViewVehicleVersion(model: any):void {
    this.selectVehicle.modelClass = model.name;
    this.selectVehicle.modelId = model.id;
    this.selectVehicle.manufacturer = model.manufacturer;

  }

  handleViewVehicleDisplace(model: any):void {
    this.selectVehicle.linkageTargetId = model.linkageTargetId;
    this.selectVehicle.linkageTargetType = model.description;
    this.stepName = 'type'
    const {  manuId, modelId } = this.selectVehicle;
    this.ecatalogService.queryDisplacement({
      "brandId": manuId,
      "modelId": modelId
    }).subscribe(res=>{
      this.vehicleDisplacementList = res.rtnData.displacementList;
    });
  }

  handleViewVehicleYear(data: any):void {
    this.selectVehicle.displacement = data;
    this.stepName = 'year'
  }

  getVehicleTypeSeries(model: any):void {
    this.ecatalogService.queryVehicleTypeSeries({
      manuId: this.selectVehicle.manuId,
      modelClass: model.name,
      manufacturer: model.manufacturer,
      modelId: model.id
    }).subscribe(res=>{
      const { linkageTargetVoList, displacementList, modelYearList } = res.rtnData ;
      this.vehicleTypeList = linkageTargetVoList || [];
      this.vehicleYearList = modelYearList || [];
      this.vehicleDisplacementList = displacementList || [];
    });
  }

  // 选择vehicle 年款
  handleSelectYears(data: any):void {
    this.selectVehicle.year = data;
  }

  // 取消
  handleCancel(){
      const country = localStorage.getItem("country");
      this.mobileProductService.sendVehicleParams({
        vehicle: {},
        isMobile: true,
        type: "vehicle",
        vehicleText: "",
        tabIndex: 1
      })
      this.router.navigate(
        [`${country}/ecatalog`],
      );
  }
  // 点击跳过
  handleSkip():void {
    if(this.stepName === 'version'){
      this.stepName = 'type'
    } else if(this.stepName === 'type'){
      this.stepName = 'year'
    }
  }
  // 点击确认
  handleConfirm():void {
    const { brand, linkageTargetType, linkageTargetId, manufacturer, modelClass, displacement, year, manuId, modelId } = this.selectVehicle;
    if(this.stepName === 'brand'){
      this.stepName = 'version'
      this.getVehicleTypeSeries({name: modelClass, id: modelId, manufacturer})
    } else if(this.stepName === 'year'){

      const country = localStorage.getItem("country");
      this.mobileProductService.sendVehicleParams({
        vehicle: {
          manuId,
          modelId,
          modelClass,
          manufacturer,
          linkageTargetType,
          linkageTargetId,
          year: year ? [year]: [],
          displacement: year ? [displacement]: [],
        },
        isMobile: true,
        type: 'vehicle',
        vehicleText: this.selectVehicleParams,
        tabIndex: 1
      })
      this.router.navigate(
        [`${country}/ecatalog`],
      );
    }
  }
}
